<template lang="pug">
  div.bank-books-individuals
    router-view(
      @success="onSuccessCreateIndividual"
      :parentItem="model"
    )

    div.body.body-table
      div.table-choose-panel
        div.toolbar-table
          e-select-list(
            :options="selectListOptions"
            v-model="operationType"
          )

          div.toolbar.toolbar--modal
            div.line
              div.parameters
              div.actions-panel
                e-button-add(
                  label="Новое физическое лицо"
                  @click="createIndividual()"
                ).btn-with-text
                e-button-add(
                  @click="addNewRow()"
                )

        div(:class="{'is-invalid': getError}")
          e-table-editable(
            ref="editTable"
            :onlyOneAdd="false"
            :tableInOnlineMode="false"
            :attributes="attr"
            :dataUrl="dataEndpoint"
            :postUrl="() => null"
            :patchUrl="() => null"
            :deleteUrl="() => null"
            :prepareRow="prepareRow"
            :defaultColumnWidth="100"
            :afterFetchData="afterFetchData"
            :afterValidate="afterValidate"
          )
        div.invalid-relative-container
          transition(v-if="getError" name="fade")
            span( v-show="error").invalid.error {{error}}

</template>

<script>
  import {individuals, core} from "../../../api/api-endpoints"
  import {editableValidatorMixin} from "../../../components/table-editable/editable-validator-mixin";
  import {IS_OWNER, IS_NOT_OWNER} from "../types/types"
  import {url} from "../../../utils/url"

  const Model = () => {
    return {
      individual_id: '',
      fullName: '',
      date_of_birth: '',
      is_owner: IS_NOT_OWNER,
      part: '',
      part_in_m2: ''
    }
  }

  export default {
    name: 'bank-books-individuals',
    mixins: [editableValidatorMixin],
    props: {
      tabView: null,
      dataUrl: {
        type: Function
      },
      model: {
        type: Object
      }
    },
    data () {
      return {
        operationType: null,
        sort: null,
        paginationQuery: null
      }
    },
    created () {
      this.fetchData()
    },
    computed: {
      collection () {
        return this.$store.getters.readUrlEndpoint(
          this.getCollectionEndpoint()
        ) || {}
      },
      identityCardTypesById () {
        const cardsById = {}
        if (this.identityCardTypes) {
          this.identityCardTypes.forEach(({id, name}) => {
            cardsById[id] = name
          })
        }
        
        return cardsById
      },
      identityCardTypes () {
        return this.collection.identity_card_type
      },
      dataEndpoint () {
        return this.dataUrl()
      },
      selectListOptions () {
        return [
          {
            id: 'detail',
            name: 'Физические лица'
          }
        ]
      },
      attr () {
        return {
          id: {
            label: "Номер",
            placeholder: 'Будет сгенерирован после сохранения',
            validationRulePattern: '(\\.*)',
            disabled: true,
            transform: (model) => model.id ? model.id : 'Будет сгенерирован после сохранения'
          },
          fullName: {
            label: 'ФИО',
            validationRulePattern: '(\\.*)',
            placeholder: 'Начните вводить ФИО',
            required: true,
            suggestion: {
              options: [],
              onSelect: this.onSelect,
              suggestionEndpoint: this.suggestionEndpoint,
              transformSuggestions: this.transformSuggestions,
              nameKey: 'label'
            },
            width: 150
          },
          date_of_birth: {
            label: "Дата рождения",
            placeholder: ' ',
            validationRulePattern: '(\\.*)',
            disabled: true
          },
          part: {
            label: "Доля собственности (в процентах)",
            placeholder: ' ',
            validationRulePattern: '([0-9*])',
            required: true
          },
          part_in_m2: {
            label: "Доля собственности (в кв.м.)",
            placeholder: ' ',
            validationRulePattern: '(\\.*)',
            disabled: true
          },
          is_owner: {
            label: "Владелец ЛС",
            validationRulePattern: '(\\.*)',
            required: true,
            select: {
              options: [
                {id: IS_NOT_OWNER, name: 'Нет'},
                {id: IS_OWNER, name: 'Да'}
              ]
            },
            transform: (model) => model.is_owner === IS_OWNER ? 'Да' : 'Нет'
          }
        }
      }
    },
    methods: {
      routeExist (route) {
        const link = this.$router.resolve(route)
        return !!(link && link.href !== '/')
      },
      createIndividual () {
        const route = url.getRoute(this.$route)
        route.name += '.individual.create'
        route.query.prevRoute = url.getRoute(this.$route, true)

        if (this.routeExist(route)) {
          this.$router.push(route)
        } else {
          this.$e.warningBox('Действие недоступно')
        }
      },
      getFullName (p) {
        return `${p.surname || ''} ${p.name || ''} ${p.patronymic || ''}`
      },
      onSuccessCreateIndividual ({fields: p}) {
        const person = new Model()
        person.date_of_birth = p.date_of_birth
        person.individual_id = p.id
        person.surname = p.surname
        person.name = p.name
        person.patronymic = p.patronymic
        person.part = 0
        person.part_in_m2 = 0
        this.$refs.editTable.createRow(person, (model) => {
          console.log('createdModel', model)
        })
      },
      afterFetchData (_, data) {
        data.data.forEach(p => {
          p.fullName = this.getFullName(p)
          this.calcPartInM2(p)
        })
        return data
      },
      /**
       * @override
       */
      getTableRef () {
        return this.$refs.editTable
      },
      getCollectionEndpoint () {
        return core.collection('identity_card_type')
      },
      fetchData () {
        this.$store.dispatch('updateUrlEndpoint', {
          endpoint: this.getCollectionEndpoint(),
          useCache: true,
          params: {
            disableGlobalError: true
          }
        })
      },
      afterValidate (ctx, model, errors) {
        const items = ctx.getData()
        // create owners and uniq individuals maps
        const owners = []
        const individuals = {}
        items.forEach(item => {
          const id = item.id || item._storeUUID
          if (item.is_owner === IS_OWNER) {
            owners.push(id)
          }
          if (item.individual_id) {
            if (!individuals[item.individual_id]) {
              individuals[item.individual_id] = []
            }
            individuals[item.individual_id].push(id)
          }
        })
        // validate owners count
        if (model.is_owner === IS_OWNER && owners.length > 1) {
          errors.is_owner = 'Допустим только один владелец'
        }
        // validate individual_id is uniq
        for (let individId in individuals) {
          if (individuals[individId].length > 1) {
            errors.fullName = 'У нескольких записей одно физ лицо'
            break
          }
        }
        // valaidte percant
        if (model.part > 100 || model.part < 0) {
          errors.part = 'Допустимы знач. от 0 до 100'
        }
        return errors
      },
      calcPartInM2 (model) {
        model.part_in_m2 = ''
        if (model.part) {
          let partInM2 = (model.part / 100) * this.model.square
          if (!isNaN(partInM2)) {
            model.part_in_m2 = partInM2.toFixed(2)
          }
        }
      },
      prepareRow (model) {
        this.calcPartInM2(model)
        return model
      },
      onSelect (ctx, $event, model) {
        // set data for show in offline mode
        // in owner section on tab1
        const copyFields = [
          'date_of_birth',
          'identity_card_issue_date',
          'identity_card_number',
          'identity_card_series',
          'identity_card_type_id',
          'snils'
        ]
        if ($event && $event.id) {
          let copy = Object.assign({}, $event)
          model.individual_id = copy.id
          model.fullName = `${copy.surname} ${copy.name} ${copy.surname}`
          copyFields.forEach(fName => {
            model[fName] = copy[fName]
          })
        } else {
          model.individual_id = ''
          model.fullName = ''
          model.date_of_birth = ''
          copyFields.forEach(fName => {
            model[fName] = ''
          })
        }
      },
      suggestionEndpoint (ctx, q) {
        return individuals.individuals({query: {q, 'per-page': 50}})
      },
      transformSuggestions (ctx, data) {
        return data.data.map(p => {
          p.label = `${p.surname} ${p.name} ${p.patronymic}, ${p.date_of_birth},
        ${this.identityCardTypesById[p.identity_card_type_id] || ''}
        ${p.identity_card_series} № ${p.identity_card_number} от ${p.identity_card_issue_date}`
          return p
        })
      },
      addNewRow () {
        this.$refs.editTable.createRow(new Model())
      }
    }
  }
</script>
